import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { Functionalities } from 'src/app/services/auth/functionalities';

// planning block height + 1px gap, see $planningHeight(Team) in planning-overview.component.scss
export const PLANNING_ROW_HEIGHT = 57;
export const TEAM_ROW_HEIGHT = 66;
export const USE_ONCE_TEAM_ROW_HEIGHT = 86;

export class PlanningOverviewViewModel {
    openEntity = false;
    addPlanning = false;
    addPlanningFixed = false;
    lockPlanning = false;

    updateViewState() {
        this.openEntity = AuthorisationService.hasFunctionality(Functionalities.EntitiesManagement);
        this.addPlanning = AuthorisationService.hasAnyFunctionality([
            Functionalities.PlanningOverviewOwn,
            Functionalities.PlanningOverviewManagement,
        ]);
        this.addPlanningFixed = AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement);
        this.lockPlanning = AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement);
    }
}
